import React, { PureComponent } from 'react'
import {
  Grid,
  TableRow,
  Table,
  TableHead,
  TableCell,
  Paper,
  Button,
  TableBody,
  TableFooter,
  ListItem,
  FormLabel,
  Tooltip,
  Select,
} from '@material-ui/core'
import moment from 'moment'
import MenuItem from '@material-ui/core/MenuItem/MenuItem'
import ModalDialog from '../common/ModalDialog'
import QuickBookSyncErrorLogs from './QuickBookSyncErrorLogs'
import { getQuickBookSyncErrors } from '../../actions/thirdParty'
import { connect } from 'react-redux'

class QuickBookLogs extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      page: 1,
      rowsPerPage: 10,
    }
  }

  handleChangePage = (page, count) => (event) => {
    if (count >= 1 && count <= Math.ceil(this.props.logs.total / this.state.rowsPerPage)) {
      this.setState({
        page: count,
      })
      this.getQuickBookSyncLogs((count - 1) * 10, this.state.rowsPerPage)
    }
    this.forceUpdate()
  }

  getQuickBookSyncLogs(start, limit) {
    this.props.getQuickBookSyncLogs(start, limit)
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value })
    this.forceUpdate()
    this.getQuickBookSyncLogs((this.state.page - 1) * 10, event.target.value)
  }

  openErrorLogs = (id) => {
    this.getQuickBookErrorLogs(id).then(() => {
      this.errorModal.handleClickOpen()
    })
  }

  getQuickBookErrorLogs = (referenceId, start = 0, limit = 10) => {
    let data = {
      reference: referenceId,
      start: start,
      limit: limit,
    }
    return this.props.dispatch(getQuickBookSyncErrors(data)).then((res) => {
      this.setState({
        errorLogs: res,
        reference: referenceId,
      })
    })
  }

  render() {
    let total = this.props.logs.total || 0
    const pages = Math.ceil(total / this.state.rowsPerPage)
    let page = this.state.page
    return (
      <div>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Paper className="margin-top-small">
            <div className="table-scroll">
              {this.props.logs && this.props.logs.values && this.props.logs.values.length > 0 ? (
                <div>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Entity</TableCell>
                        <TableCell>Last Sync Date</TableCell>
                        <TableCell>Total Success</TableCell>
                        <TableCell>Total Fail</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.props.logs &&
                        this.props.logs.values &&
                        this.props.logs.values
                          .filter((value) => value.syncType === 'Push')
                          .map((logs, index) => {
                            return (
                              <TableRow key={index}>
                                <TableCell>{logs.quickbookEntityType}</TableCell>
                                <TableCell>
                                  {moment(logs.endTime).format('hh:mmA')}{' '}
                                  {moment(logs.endTime).format('MM/DD/YYYY')}
                                </TableCell>
                                <TableCell>{logs.total_Sync}</TableCell>
                                <TableCell>{logs.total_fail}</TableCell>
                                <TableCell>{logs.status}</TableCell>
                                <TableCell>
                                  {logs.status === 'Fail' || logs.status === 'PartialSuccess' ? (
                                    <Button
                                      className="danger-button"
                                      onClick={this.openErrorLogs.bind(this, logs.id)}
                                    >
                                      &nbsp;View Errors
                                    </Button>
                                  ) : (
                                    ''
                                  )}
                                </TableCell>
                              </TableRow>
                            )
                          })}
                    </TableBody>
                    <TableFooter>
                      <TableRow>
                        <TableCell colSpan={5}>
                          <ul className="pagination">
                            <li>Rows per page</li>
                            <li>
                              <Select
                                value={this.state.rowsPerPage}
                                onChange={this.handleChangeRowsPerPage}
                                displayEmpty
                              >
                                <MenuItem value={10}>10</MenuItem>
                                <MenuItem value={20}>20</MenuItem>
                                <MenuItem value={30}>30</MenuItem>
                              </Select>
                            </li>
                            <li>
                              {this.state.page} of {pages}
                            </li>
                            <li>
                              <Tooltip title="Previous" aria-label="Previous">
                                <Button onClick={this.handleChangePage('prv', page - 1)}>
                                  <i className="material-icons">chevron_left</i>
                                </Button>
                              </Tooltip>
                            </li>
                            <li>
                              <Tooltip title="Next" aria-label="Next">
                                <Button onClick={this.handleChangePage('next', page + 1)}>
                                  <i className="material-icons">chevron_right</i>
                                </Button>
                              </Tooltip>
                            </li>
                          </ul>
                        </TableCell>
                      </TableRow>
                    </TableFooter>
                  </Table>
                </div>
              ) : (
                <ListItem>
                  <FormLabel component="legend">Logs not available</FormLabel>
                </ListItem>
              )}
            </div>
          </Paper>
          <ModalDialog
            title="Sync Error Logs"
            ref={(c) => (this.errorModal = c)}
            maxWidth="md"
            hideSave={true}
            cancelText="Close"
            paperStyle={{ maxWidth: '100%', minWidth: '80%' }}
          >
            <QuickBookSyncErrorLogs
              errorLogs={this.state.errorLogs || null}
              apiCall={this.getQuickBookErrorLogs.bind(this)}
              reference={this.state.reference || ''}
            />
          </ModalDialog>
        </Grid>
      </div>
    )
  }
}

export default connect((state) => ({ dispatch: state.dispatch }))(QuickBookLogs)



// WEBPACK FOOTER //
// ./src/components/QuickBook/QuickBookLogs.js